import { authGet } from '../utils/fecth-wrappers';
import constants from '../constants/appConstants';

export const getIdByDealershipName = dealershipName => {
  return authGet(`${constants.API.dealership}?dealershipName=${dealershipName}`);
};
